module.exports = __webpack_public_path__ + "static/media/news2.211e5c7a.svg";